import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "node",
  style: {"--offset-left":"3","--offset-top":"2","--data-color":"var(--color-data-raster)","--data-color-dim":"var(--color-data-raster-dim)"}
}
const _hoisted_2 = { class: "primary" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ports" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "output port",
    "data-datatype": "raster"
  }, [
    /*#__PURE__*/_createElementVNode("div")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Image")
const _hoisted_5 = {
  class: "node",
  style: {"--offset-left":"9","--offset-top":"2","--data-color":"var(--color-data-raster)","--data-color-dim":"var(--color-data-raster-dim)"}
}
const _hoisted_6 = { class: "primary" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "ports" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "input port",
    "data-datatype": "raster"
  }, [
    /*#__PURE__*/_createElementVNode("div")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "output port",
    "data-datatype": "raster"
  }, [
    /*#__PURE__*/_createElementVNode("div")
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Mask")
const _hoisted_9 = { class: "arguments" }
const _hoisted_10 = { class: "argument" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "ports" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "input port",
    "data-datatype": "raster",
    style: {"--data-color":"var(--color-data-raster)","--data-color-dim":"var(--color-data-vector-dim)"}
  }, [
    /*#__PURE__*/_createElementVNode("div")
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Stencil")
const _hoisted_13 = {
  class: "node",
  style: {"--offset-left":"15","--offset-top":"2","--data-color":"var(--color-data-raster)","--data-color-dim":"var(--color-data-raster-dim)"}
}
const _hoisted_14 = { class: "primary" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "ports" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "output port",
    "data-datatype": "raster"
  }, [
    /*#__PURE__*/_createElementVNode("div")
  ])
], -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Transform")
const _hoisted_17 = {
  class: "node",
  style: {"--offset-left":"21","--offset-top":"2","--data-color":"var(--color-data-raster)","--data-color-dim":"var(--color-data-raster-dim)"}
}
const _hoisted_18 = { class: "primary" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "ports" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "input port",
    "data-datatype": "raster"
  }, [
    /*#__PURE__*/_createElementVNode("div")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "output port",
    "data-datatype": "raster"
  }, [
    /*#__PURE__*/_createElementVNode("div")
  ])
], -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Motion Blur")
const _hoisted_21 = { class: "arguments" }
const _hoisted_22 = { class: "argument" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "ports" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "input port",
    "data-datatype": "raster"
  }, [
    /*#__PURE__*/_createElementVNode("div")
  ])
], -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Strength")
const _hoisted_25 = {
  class: "node",
  style: {"--offset-left":"2","--offset-top":"5","--data-color":"var(--color-data-vector)","--data-color-dim":"var(--color-data-vector-dim)"}
}
const _hoisted_26 = { class: "primary" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "ports" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "output port",
    "data-datatype": "vector"
  }, [
    /*#__PURE__*/_createElementVNode("div")
  ])
], -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Shape")
const _hoisted_29 = {
  class: "node",
  style: {"--offset-left":"6","--offset-top":"7","--data-color":"var(--color-data-raster)","--data-color-dim":"var(--color-data-raster-dim)"}
}
const _hoisted_30 = { class: "primary" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "ports" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "output port",
    "data-datatype": "raster"
  }, [
    /*#__PURE__*/_createElementVNode("div")
  ])
], -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Brushwork")
const _hoisted_33 = {
  class: "node",
  style: {"--offset-left":"12","--offset-top":"7","--data-color":"var(--color-data-raster)","--data-color-dim":"var(--color-data-raster-dim)"}
}
const _hoisted_34 = { class: "primary" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "ports" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "output port",
    "data-datatype": "raster"
  }, [
    /*#__PURE__*/_createElementVNode("div")
  ])
], -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Blur")
const _hoisted_37 = {
  class: "node",
  style: {"--offset-left":"12","--offset-top":"9","--data-color":"var(--color-data-raster)","--data-color-dim":"var(--color-data-raster-dim)"}
}
const _hoisted_38 = { class: "primary" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "ports" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "output port",
    "data-datatype": "raster"
  }, [
    /*#__PURE__*/_createElementVNode("div")
  ])
], -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Gradient")
const _hoisted_41 = { ref: "wiresContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LayoutRow = _resolveComponent("LayoutRow")!
  const _component_IconLabel = _resolveComponent("IconLabel")!
  const _component_TextLabel = _resolveComponent("TextLabel")!
  const _component_LayoutCol = _resolveComponent("LayoutCol")!

  return (_openBlock(), _createBlock(_component_LayoutCol, { class: "node-graph" }, {
    default: _withCtx(() => [
      _createVNode(_component_LayoutRow, { class: "options-bar" }),
      _createVNode(_component_LayoutRow, {
        class: "graph",
        onWheel: _cache[0] || (_cache[0] = (e) => _ctx.scroll(e)),
        ref: "graph",
        onPointerdown: _cache[1] || (_cache[1] = (e) => _ctx.pointerDown(e)),
        onPointermove: _cache[2] || (_cache[2] = (e) => _ctx.pointerMove(e)),
        onPointerup: _cache[3] || (_cache[3] = (e) => _ctx.pointerUp(e)),
        style: _normalizeStyle(`--grid-spacing: ${_ctx.gridSpacing}px; --grid-offset-x: ${_ctx.transform.x * _ctx.transform.scale}px; --grid-offset-y: ${_ctx.transform.y * _ctx.transform.scale}px; --dot-radius: ${_ctx.dotRadius}px`)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "nodes",
            ref: "nodesContainer",
            style: _normalizeStyle({
					transform: `scale(${_ctx.transform.scale}) translate(${_ctx.transform.x}px, ${_ctx.transform.y}px)`,
					transformOrigin: `0 0`,
				})
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createVNode(_component_IconLabel, {
                  icon: 'NodeImage',
                  iconStyle: 'Node'
                }),
                _createVNode(_component_TextLabel, null, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_IconLabel, {
                  icon: 'NodeMask',
                  iconStyle: 'Node'
                }),
                _createVNode(_component_TextLabel, null, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_TextLabel, null, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_IconLabel, {
                  icon: 'NodeTransform',
                  iconStyle: 'Node'
                }),
                _createVNode(_component_TextLabel, null, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_IconLabel, {
                  icon: 'NodeMotionBlur',
                  iconStyle: 'Node'
                }),
                _createVNode(_component_TextLabel, null, {
                  default: _withCtx(() => [
                    _hoisted_20
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(_component_TextLabel, null, {
                    default: _withCtx(() => [
                      _hoisted_24
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createVNode(_component_IconLabel, {
                  icon: 'NodeShape',
                  iconStyle: 'Node'
                }),
                _createVNode(_component_TextLabel, null, {
                  default: _withCtx(() => [
                    _hoisted_28
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createVNode(_component_IconLabel, {
                  icon: 'NodeBrushwork',
                  iconStyle: 'Node'
                }),
                _createVNode(_component_TextLabel, null, {
                  default: _withCtx(() => [
                    _hoisted_32
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createVNode(_component_IconLabel, {
                  icon: 'NodeBlur',
                  iconStyle: 'Node'
                }),
                _createVNode(_component_TextLabel, null, {
                  default: _withCtx(() => [
                    _hoisted_36
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode(_component_IconLabel, {
                  icon: 'NodeGradient',
                  iconStyle: 'Node'
                }),
                _createVNode(_component_TextLabel, null, {
                  default: _withCtx(() => [
                    _hoisted_40
                  ]),
                  _: 1
                })
              ])
            ])
          ], 4),
          _createElementVNode("div", {
            class: "wires",
            style: _normalizeStyle({
					transform: `scale(${_ctx.transform.scale}) translate(${_ctx.transform.x}px, ${_ctx.transform.y}px)`,
					transformOrigin: `0 0`,
				})
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_41, null, 512))
          ], 4)
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}